import React, { useState, useEffect } from "react";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import "../../assets/css/contents/popup.css";

const API_BASE_URL = "https://homepage-api.neulgo.com";
const DOMAIN_ID = 16;

const popupApi = axios.create({ baseURL: API_BASE_URL });

function isYouTubeUrl(url) {
    return /youtube\.com|youtu\.be/.test(url);
}

function getYouTubeEmbedUrl(url) {
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : url;
}

function isPopupVisible(popup) {
    const hideUntil = localStorage.getItem(`hidePopupUntil:${popup.id}`);
    if (hideUntil && new Date().getTime() < new Date(hideUntil).getTime()) {
        return false;
    }

    if (popup.startAt && popup.endAt) {
        const now = new Date().getTime();
        const start = new Date(popup.startAt).getTime();
        const end = new Date(popup.endAt).getTime();
        if (now < start || now > end) return false;
    }

    return true;
}

function PopupItem({ popup, isMobile, onClose }) {
    const handleHide24Hours = () => {
        const hideUntil = new Date();
        hideUntil.setDate(hideUntil.getDate() + 1);
        localStorage.setItem(`hidePopupUntil:${popup.id}`, hideUntil.toISOString());
        onClose(popup.id);
    };

    const handleClick = () => {
        if (popup.url) {
            if (isYouTubeUrl(popup.url)) {
                window.open(getYouTubeEmbedUrl(popup.url), "_blank");
            } else {
                window.open(popup.url, "_self");
            }
        }
    };

    const containerStyle = isMobile
        ? {}
        : {
              width: popup.width || 300,
              top: popup.topCoordinate || 100,
              left: popup.leftCoordinate || 80,
          };

    const mediaHeight = isMobile ? "auto" : popup.height || 250;

    const renderMedia = () => {
        if (popup.movieUrl) {
            if (isYouTubeUrl(popup.movieUrl)) {
                return (
                    <iframe
                        width="100%"
                        height={mediaHeight}
                        src={getYouTubeEmbedUrl(popup.movieUrl)}
                        frameBorder="0"
                        allowFullScreen
                        title="팝업 영상"
                    />
                );
            }
            return (
                <video width="100%" height={mediaHeight} controls>
                    <source src={popup.movieUrl} type="video/mp4" />
                </video>
            );
        }
        return <img src={popup.s3Url} alt="팝업 배너" className="popup-image" />;
    };

    return (
        <div
            className={isMobile ? "popup-container popup-container-mobile" : "popup-container"}
            style={containerStyle}
        >
            <button
                className="popup-image-wrapper"
                type="button"
                onClick={popup.url ? handleClick : undefined}
                style={{ cursor: popup.url ? "pointer" : "default" }}
            >
                {renderMedia()}
            </button>

            <div className="popup-footer">
                <button className="popup-hide-24h-btn" onClick={handleHide24Hours}>
                    24시간 동안 다시 열람하지 않습니다.
                </button>
                <button className="popup-close-text-btn" onClick={() => onClose(popup.id)}>
                    닫기
                </button>
            </div>
        </div>
    );
}

function Popup() {
    const [popups, setPopups] = useState([]);
    const [visibleIds, setVisibleIds] = useState([]);
    const isMobile = useMediaQuery({ maxWidth: 767 });

    useEffect(() => {
        popupApi
            .get(`api/v1/popups/domain/${DOMAIN_ID}?type=HOMEPAGE`)
            .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                    const data = res.data;
                    const visible = data.filter(isPopupVisible).map((p) => p.id);
                    setPopups(data);
                    setVisibleIds(visible);
                }
            })
            .catch(() => {
                // 팝업 로드 실패 시 조용히 무시
            });
    }, []);

    const handleClose = (popupId) => {
        setVisibleIds((prev) => prev.filter((id) => id !== popupId));
    };

    const visiblePopups = popups.filter((p) => visibleIds.includes(p.id));

    if (visiblePopups.length === 0) return null;

    return (
        <div className="popup openModal">
            <div className="popup-list">
                {visiblePopups.map((popup) => (
                    <PopupItem
                        key={popup.id}
                        popup={popup}
                        isMobile={isMobile}
                        onClose={handleClose}
                    />
                ))}
            </div>
        </div>
    );
}

export default Popup;
